export default "* Jægerstenaldermad\n* Bål\n* Samle/sanke\n* Fiske\n* Jage\n";